var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-pill",attrs:{"disabled":_vm.disabled,"type":"button"}},[_c('i',{class:[_vm.iconClass, 'bx-xs mr-2']}),_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }